export default __webpack_public_path__ + "static/media/MT3_activations_XY.eb6a6d9b.png";